import * as ast from '../../generated/ast.js';
import { NodeFields } from '../../common/node-fields.js';
import { RichAssetTypesDisplayNames } from '../../common/mappings.js';
import { FRONTEND_PROPERTY_NAME } from '../../common/constants.js';
export function validateNextNodes(node, nodeFields, accept) {
    const { idField, nodeTypeField, nextNodesField, richAssetField } = nodeFields;
    // nextNodes is only for decision nodes
    if (nodeTypeField?.nodeType?.value !== 'D')
        return;
    // For certain rich asset types, we should only have 0 or 1
    // items in the nextNodes field
    if (richAssetField &&
        (ast.isRichAssetDatePicker(richAssetField?.content) ||
            ast.isRichAssetTimePicker(richAssetField?.content) ||
            ast.isRichAssetFileUpload(richAssetField?.content)) &&
        nextNodesField?.nextNodes &&
        nextNodesField?.nextNodes?.length > 1) {
        accept('error', `Can only have 0 or 1 nextNodes when ${RichAssetTypesDisplayNames[richAssetField.content.$type]} is specified.`, {
            node: nextNodesField,
            data: {
                id: idField?.id?.value,
                nodeNumber: node?.name,
                propertyName: FRONTEND_PROPERTY_NAME.NEXT_NODES,
            },
        });
    }
    // We have some additional checks to run if the file_upload
    // is of type action_node
    if (richAssetField &&
        ast.isRichAssetFileUpload(richAssetField?.content) &&
        ast.isFileUploadJson(richAssetField?.content?.value)) {
        const fileUploadJson = richAssetField.content.value;
        // Find the type property
        const typeProperty = fileUploadJson.properties.find((prop) => {
            return ast.isFileUploadTypeProperty(prop);
        });
        if (typeProperty?.type === 'action_node') {
            // We should have exactly one next node
            if (!nextNodesField ||
                !nextNodesField.nextNodes ||
                nextNodesField.nextNodes.length !== 1) {
                accept('error', `File upload node of type 'action_node' must have exactly one child node specified in the next nodes field.`, {
                    node,
                    data: {
                        id: idField?.id?.value,
                        nodeNumber: node?.name,
                        propertyName: FRONTEND_PROPERTY_NAME.NEXT_NODES,
                    },
                });
            }
            else {
                // Get the next node that is being referenced for further checks
                const nextNodeRef = nextNodesField?.nextNodes?.[0]?.ref;
                const refNodeFields = new NodeFields(nextNodeRef);
                // Ensure that the referenced node is an action node
                const { nodeTypeField: refNodeTypeField, commandField: refCommandField, } = refNodeFields;
                if (refNodeTypeField?.nodeType?.value !== 'A') {
                    accept('error', `File upload node of type 'action_node' must have an action node as their next node.`, {
                        node: nextNodesField,
                        data: {
                            id: idField?.id?.value,
                            nodeNumber: node?.name,
                            propertyName: FRONTEND_PROPERTY_NAME.NEXT_NODES,
                        },
                    });
                }
                else {
                    // Get the action_script property of the file_upload
                    const actionScriptProperty = fileUploadJson.properties.find((prop) => {
                        return ast.isActionScriptProperty(prop);
                    });
                    // The action_script property value should match the command
                    // property of the referenced node
                    if (actionScriptProperty &&
                        actionScriptProperty.actionScript?.value !==
                            refCommandField?.command?.value) {
                        accept('error', `File upload node command must be the same as the command of the following action node.`, {
                            node,
                            data: {
                                id: idField?.id?.value,
                                nodeNumber: node?.name,
                                propertyName: FRONTEND_PROPERTY_NAME.NEXT_NODES,
                            },
                        });
                    }
                }
            }
        }
    }
}
//# sourceMappingURL=validate-next-nodes.js.map